//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import footerNav from '@/components/footer/footer'
import undoTaskImg from '@/assets/images/personal/个人中心_任务_未选.png'
import taskImg from '@/assets/images/personal/个人中心_任务_已选.png'
import myDatumImg from '@/assets/images/personal/个人中心_完善资料_头像.png'
import myCourseImg from '@/assets/images/personal/个人中心_必修课.png'
import myExamImg from '@/assets/images/personal/个人中心_考试.png'
import mySchoolImg from '@/assets/images/personal/个人中心_学校.png'
import mySigninImg from '@/assets/images/personal/个人中心_考勤.png'

import {Toast,Indicator} from 'mint-ui'
import {MessageBox} from 'mint-ui'
import {Const} from '@/consts'
import userApi from '@/api/user'
import indexApi from '@/api/index'
import utils from '@/utils'
import wechatApi from "@/api/wechat"
import wx from "weixin-js-sdk";

export default {
    data() {
        return {
            studentId:"",
            userid:'',
            img: {
                undoTask: undoTaskImg,
                task: taskImg,
                myDatum: myDatumImg,
                myCourse: myCourseImg,
                myExam: myExamImg,
                mySchool: mySchoolImg,
                mySignin: mySigninImg
            },
            studentDataApprovalDesc: '',
            studyAgainFlag: false,
            canChangeSchool: false,
            userJoinSchool:true,
            myCourse: null,
            myCourse2: null,
            userInfo: {},
            creditInfo: {},
            myProgress: 0,
            mySchool: {},
            taskStatus: {},
            taskInfo: {
                course: {active: 0, canClick: 0},
                completeInfo: {active: 0, canClick: 0},
                exam: {active: 0, canClick: 0},
                school: {active: 0, canClick: 0},
                exercise: {active: 0, canClick: 0},
                returnVisit: {active: 0, canClick: 0}
            },
            courseDisplayInfo: {
                '1': false,
                '2': false
            }
        }
    },

    components: {
        footerNav
    },

    /*computed: {
        taskInfo () {
            //亮 1 不亮0
            //可点 1 不可点0
            let course={};
            if(this.taskStatus.course=='doing')
            {
                course.active=0;
                course.canClick=1;
            }else if(this.taskStatus.course=='completed')
            {
                course.active=1;
                course.canClick=1;
            }else
            {
                course.active=0;
                course.canClick=1;
            }

            let completeInfo={};
            if(this.taskStatus.completeInfo=='doing')
            {
                completeInfo.active=0;
                completeInfo.canClick=1;
            }else if(this.taskStatus.completeInfo=='completed')
            {
                completeInfo.active=1;
                completeInfo.canClick=1;
            }else
            {
                completeInfo.active=0;
                completeInfo.canClick=1;
            }

            let exam={};
            if(this.taskStatus.exam=='doing')
            {
                exam.active=1;
                exam.canClick=1;
            }else if(this.taskStatus.exam=='completed')
            {
                exam.active=1;
                exam.canClick=0;
            }else
            {
                exam.active=0;
                exam.canClick=0;
            }

            let school={};
            if(this.taskStatus.school=='doing')
            {
                school.active=0;
                school.canClick=1;
            }else if(this.taskStatus.school=='completed')
            {
                school.active=1;
                school.canClick=1;
            }else
            {
                school.active=0;
                school.canClick=1;
            }

            let exercise={};
            if(this.taskStatus.exercise=='doing')
            {
                exercise.active=1;
                exercise.canClick=1;
            }else if(this.taskStatus.exercise=='completed')
            {
                exercise.active=1;
                exercise.canClick=0;
            }else
            {
                exercise.active=0;
                exercise.canClick=0;
            }

            let returnVisit={};
            if(this.taskStatus.returnVisit=='doing')
            {
                returnVisit.active=0;
                returnVisit.canClick=1;
            }else if(this.taskStatus.returnVisit=='completed')
            {
                returnVisit.active=1;
                returnVisit.canClick=1;
            }else
            {
                returnVisit.active=0;
                returnVisit.canClick=0;
            }
            return {
                course: course,
                completeInfo: completeInfo,
                exam: exam,
                school: school,
                exercise: exercise,
                returnVisit: returnVisit
            }
        }
    },*/

    created() {
        // this.userInfo = utils.get('USER_INFO') || {};
        this.getUserInfo();
        this.getInfoDetail();
        this.getCreditInfo();
        this.getStudentStudyAgainStatus();
        this.getStudentDataApproveInfo();
        this.wechatPosition();
        // this.getMyCourse();
        // this.getMyProgress();
        console.log(this.$route.query.id)
        if(typeof (this.$route.query.id) !== 'undefined'){
            Indicator.open('身份验证中...');

            userApi.sureFaceidChkdsk({
                params: {
                    id: this.$route.query.id
                }

            }).then((resp) => {
                Indicator.close();
                const result = resp[Const.RESP_RESULT] || {};
                if(result===0){
                    location.reload()
                }

                //this.$router.push({path: '/personal'})
                //location.reload()

            }).catch((resp) => {
                Indicator.close();
                // Toast(resp[Const.RESP_MESSAGE]);
                if (resp.statusCode == '200') {
                    if (resp.msg === '运行时异常:没有学习进度') {
                        MessageBox('提示', '请选择课程后再次提交')
                    }
                    Toast(resp[Const.RESP_MESSAGE] || resp.msg || '出错了...')
                }
            });
        }

    },

    filters: {
        emptyText(value, extra) {
            return value ? ((extra || '') + (value || '')) : ''
        },

        stageText(value, defaultValue) {

            if (!value) {
                return '开始学习'
            }

            if (/PRACTICAL|PARTICIPATION|FINALSCORE/.test(value)) {
                return '课程完成'
            }

            return defaultValue
        }
    },

    methods: {
        joinClass(){
            wx.scanQRCode();
        },
      //更换学校
      changeSchool(){
        console.log(this.studentId)
        MessageBox({
          title: '提示',
          message: '提交换学校申请，将先由所在学校审批。审批通过则可以重新选择学校，进行学习',
          showCancelButton: true
        })
          .then(action=>{
            if(action=='confirm'){
              console.log('确定')
              userApi.changeschool({
                params: {
                  courseId: this.studentId
                }
              }).then((resp) => {
                const result = resp[Const.RESP_RESULT] || {};
                console.log(result)
              }).catch((resp) => {
                // Toast(resp[Const.RESP_MESSAGE]);
              });
            }

        }).catch(err=>{
          if(err=='cancel'){
            console.log('取消')
          }
        })
      },
        getStudentDataApproveInfo() {
            userApi.getStudentDataApproveInfo().then((resp) => {
                const result = resp[Const.RESP_RESULT];
                if (result.approvalStatus == 'REJECT' && !result.isCompleted) {
                    this.studentDataApprovalDesc = '您提交的个人资料完善,审批被拒绝,理由:[' + result.opinions + ']';
                }

            }).catch((resp) => {
                // Toast(resp[Const.RESP_MESSAGE]);
                if (resp.statusCode == '200') {
                    Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败');
                }
            });
        },
        getStudentStudyAgainStatus() {
            userApi.getStudentStudyAgainStatus().then((resp) => {
                const result = resp[Const.RESP_RESULT];
                console.log(result);
                this.studyAgainFlag = result;

            }).catch((resp) => {
                // Toast(resp[Const.RESP_MESSAGE]);
                if (resp.statusCode == '200') {
                    Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败');
                }
            });
        },
        studentProgressOver() {
            MessageBox.confirm('您确定要学习一门新课程吗?确定后,系统将保留您现在的学习情况,您可以重新选择专业及培训机构开启新的学习之旅,原学习记录不会丢失！').then(action => {
                userApi.studentProgressOver().then((resp) => {
                    Toast("您已经完成之前专业,请重新进行专业及培训机构报名开始再次培训,即将跳转到首页进行课程选择");
                    setTimeout(() => {
                        this.$router.push('/index');
                    }, 3000);
                    /*this.course=null;
                    this.myCourse2=null;
                    this.mySchool={};
                    this.taskInfo={
                        course: {active: 0 ,canClick:0},
                        completeInfo: {active:0,canClick:0},
                        exam: {active:0,canClick:0},
                        school: {active:0,canClick:0},
                        exercise: {active:0,canClick:0},
                        returnVisit: {active:0,canClick:0}
                    }*/

                }).catch((resp) => {
                    // Toast(resp[Const.RESP_MESSAGE]);
                    if (resp.statusCode == '200') {
                        Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败');
                    }
                });
            })

        },
        goSettingPage() {
            this.$router.push('/personal/setting');
        },
        goTeachPage() {
            this.$router.push('/personal/teacher/teacher');
        },
        routerPage(url) {
            this.$router.push({path: url, query: {from: 'personal'}});
        },
        goCourseInfoPage(courseId, stage, isMinor) {

            if (stage === 'EXAMINATION' && !isMinor) {

                if (this.taskInfo.completeInfo.active==0) {
                    Toast('请先完善资料')
                    return
                }

                // 开始考试
                MessageBox.confirm('<div style="height:100px;line-height:100px">您可以进行模拟练习或正式考试！</div>').then(action => {
                    this.$router.push({path: '/exam/start', query: {courseId: courseId, from: 'personal'}})
                })

                // } else if (stage === 'PRACTICAL') {
                //     // 实训报名
                // } else if (stage === 'PARTICIPATION') {
                //     // 参与实训
                // } else if (stage === 'FINALSCORE') {
                //     // 最终成绩
            } else {
                this.$router.push({path: '/index/courseInfo', query: {courseid: courseId, from: 'personal'}});
            }


        },

        processMyProgress(stage) {
            console.log(stage);
            switch (stage + '') {
                case 'SIGNUP':
                    this.myProgress = 0;
                    break;
                case 'CONTINUE':
                    this.myProgress = 1;
                    break;
                case 'COMPLETE':
                    this.myProgress = 1;
                    break;
                case 'COMPLETED':
                    this.myProgress = 2;
                    break;
                case 'EXAMINATION':
                    this.myProgress = 2;
                    break;
                case 'PRACTICAL':
                    this.myProgress = 3;
                    break;
                case 'PARTICIPATION':
                    this.myProgress = 4;
                    break;
                case 'PRACTICALCOMPLETION':
                    this.myProgress = 5;
                    break;
                case 'RETURNVISITED':
                    this.myProgress = 6;
                    break;
                case 'CERTTESTED':
                    this.myProgress = 7;
                    break;
                default:
                    this.myProgress = 0;
                    break;
            }
        },

        getMyProgress() {
            userApi.getMyProgress().then(resp => {
                const result = resp[Const.RESP_RESULT] || {};
                this.processMyProgress(result.stage)
            }).catch(resp => {
                // Toast(resp[Const.RESP_MESSAGE]);
                if (resp.statusCode == '200') {
                    Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败');
                }
            });
        },
        getStudentTrainingTaskInfo(studentId) {
            console.log(studentId)
          this.studentId = studentId
            userApi.getStudentTrainingTaskInfo({
                params: {
                    studentId: studentId
                }
            }).then((resp) => {
                const result = resp[Const.RESP_RESULT] || {};
                this.taskStatus = result.taskStatus;
                this.taskInfo = result.taskInfo;

            }).catch((resp) => {
                // Toast(resp[Const.RESP_MESSAGE]);
                if (resp.statusCode == '200') {
                    Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败');
                }
            });
        },
        getUserInfo() {
            userApi.getUserInfo().then((resp) => {
                const result = resp[Const.RESP_RESULT] || {};
                console.log(result)
                this.userInfo = {
                    username: result.username,
                    phoneNo: result.phoneno,
                    realName: result.realname,
                    idCardNo: result.idcardno,
                    avatarUrl: result.avatarurl,
                    lastLoginTime: result.lastlogintime,
                    biaoshi:result.biaoshi,
                };
                this.getStudentTrainingTaskInfo(result.userid)
                utils.save('USER_INFO', this.userInfo);
            }).catch((resp) => {
                // Toast(resp[Const.RESP_MESSAGE]);
                if (resp.statusCode == '200') {
                    Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败');
                }
            });
        },
        getCreditInfo() {
            userApi.getCreditInfo().then((resp) => {
                const result = resp[Const.RESP_RESULT] || {};
                this.creditInfo = {
                    creditBal: result.creditBal,
                    upScore: result.up,
                    downScore: result.down

                };
            }).catch((resp) => {
                // Toast(resp[Const.RESP_MESSAGE]);
                if (resp.statusCode == '200') {
                    Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败');
                }
            });
        },

        getInfoDetail() {
            userApi.getInfoDetail().then((resp) => {
                const result = resp[Const.RESP_RESULT] || {}

                // 必修课
                // this.myCourse = (result.mycourse || []).filter(t => t['coursetype'] == 'PROFESSIONAL'||t['coursetype'] == 'SPECIALABILITY'||t['coursetype'] == 'ENTERPRISE'||t['coursetype'] == 'BUSINESS')[0]
                this.myCourse = (result.mycourse || []).filter(t => t['coursetype'] != 'PUBLIC')[0]
                utils.save('USER_COURSE', this.myCourse);

                // 选修课
                this.myCourse2 = (result.mycourse || []).filter(t => t['coursetype'] == 'PUBLIC')[0]

                utils.save('USER_COURSE2', this.myCourse2);
                // 进度
                this.processMyProgress((result.mystatus || {}).stage)
                // 学校
                this.mySchool = result.myschool || {}
                this.canChangeSchool = result.canChangeSchool;
                //学员加入学校
                this.userJoinSchool = result.userJoinSchool;
                utils.save('USER_SCHOOL', this.mySchool);
            }).catch((resp) => {
                // Toast(resp[Const.RESP_MESSAGE]);
                if (resp.statusCode == '200') {
                    Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败');
                }
            });
        },

        getMyCourse() {

            let course = utils.get('USER_COURSE')
            if (course && course.title) {
                this.myCourse = course
                return
            }

            indexApi.getMyCourseList({
                params: {
                    coursetype: 'PROFESSIONAL'
                }
            }).then((resp) => {
                const result = resp[Const.RESP_RESULT] || [];
                this.myCourse = result.filter(t => t['coursetype'] == 'PROFESSIONAL')[0];
                utils.save('USER_COURSE', this.myCourse);
            }).catch((resp) => {
                // Toast(resp[Const.RESP_MESSAGE]);
                if (resp.statusCode == '200') {
                    Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败');
                }
            });
        },

        chooseMyCourse() {
            if (this.taskInfo.course.active) {
                this.$router.push({
                    path: '/index/courseInfo',
                    query: {courseid: this.myCourse.courseid, from: 'personal'}
                });
            } else {
                this.$router.push('/index?public=true&to=public');
            }

        },

        completeInfo() {

            const msgText = '<div class="text-justify" style="line-height: 25px;">该信息将用于在通过考试后、报考学校时生成纸质报名表，若信息不符可能导致报名失败，请您依照真实情况填写。其中姓名、性别、身份证号码、家庭住址上传完身份证后会自动生成，无法手动填写。<div>'

            MessageBox.confirm(msgText, '温馨提示', {
                confirmButtonText: '我已知晓',
                cancelButtonText: '我要再考虑一下',
                closeOnClickModal: false,
                type: 'info'
            }).then(action => {
                //
                this.$router.push({
                    path: '/personal/setting/complete',
                    query: {
                        from: 'personal'
                    }
                });
            }).catch(() => {

            })
        },

        startExam() {

            if (this.taskInfo.completeInfo.active == 0) {
                Toast('请先完善资料')
                return
            }

            if (!this.myCourse || this.myCourse.stage != 'EXAMINATION') {
                Toast('您现在不能考试')
            }
        },

        changeMyAvatar() {
            this.$router.push({path: '/personal/setting/account', query: {from: 'personal'}});
        },
        returnVisit() {
            if (this.myProgress >= 5) {
                this.$router.push({path: '/personal/returnVisit', query: {from: 'personal'}});
            } else {
                Toast('您现在实训培训未结束,无法进行满意度调查,请确保在完成目标课时数后,通知授课老师进行实训成绩填写,方可进行！')
            }
        },
        chooseSchool() {
            // if(!this.userJoinSchool){
            //     Toast('请联系客服或者学校进行报名！')
            //     return;
            // }

            if (this.taskInfo.school.active) {
                this.$router.push({
                    path: '/personal/school/detail',
                    query: {
                        schoolId: this.mySchool.schoolid
                    }
                });

            } else {
                this.$router.push({
                    path: '/personal/school/list',
                    query: {
                        order: '0'
                    }
                })
            }

            /*if (this.myCourse && this.myProgress >= 3) {
                this.$router.push({
                    path: '/personal/school/list',
                    query: {
                        order: '0'
                    }
                })
            } else {
                Toast('您现在还不能选择学校')
            }*/
        },

        /*punchCard() {
            if (this.mySchool && this.mySchool.schoolid) {
                this.$router.push({
                    path: '/personal/school/punchcard',
                    schoolId: this.mySchool.schoolid
                })
            } else {
                Toast('您还没有选择学校')
            }
        },*/
        punchCards() {

                this.$router.push({
                    path: '/personal/school/punchcardPlus',
                    schoolId: this.mySchool.schoolid
                })

        },
        //课程信息
        courseListInfo() {
            this.$router.push({
                path: '/personal/school/courseListInfo',
                schoolId: this.mySchool.schoolid
            })
        },

        toggleCollapse() {
            //     let target = $event.target;
            //     let className = target.className || ''

            //     let classList = className.split(/\s+/)

            //     if (classList.indexOf('clamp-text') != -1) {
            //         target.className = target.className.replace('clamp-text', '').trim()
            //     } else if (classList.length) {
            //         target.className += ' clamp-text'
            //     } else if (!classList.length) {
            //         target.className = 'clamp-text'
            //     }
        },

        handleDisplay(source, index) {
            source[index] = !source[index]
        },
        wechatPosition() {
            let me = this;
            wechatApi
                .verifyConfig4WeChat({
                    params: { url: location.href.split("#")[0] }
                })
                .then(res => {
                    if(res.status==="SUCCESS"){
                        wx.config({
                            debug: false,
                            appId: "wx242a30c67d7c5cb3",
                            nonceStr: res.result.nonceStr,
                            signature: res.result.signature,
                            timestamp: res.result.timestamp,
                            jsApiList: ["scanQRCode"]
                        });

                        wx.ready(res => {

                        });
                        wx.error(function(res) {

                            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                            console.log(res);
                        });
                    }
                });
        },

    }
}



// WEBPACK FOOTER //
// ./src/view/personal/personal.vue